import React from 'react';
import classnames from 'classnames';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      alignment: 'left',
    };
    this.calculateAlignment = this.calculateAlignment.bind(this);
    this.handleTouchOutside = this.handleTouchOutside.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  componentDidMount() {
    document.addEventListener('touchstart', this.handleTouchOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('touchstart', this.handleTouchOutside);
  }

  handleTouchOutside(event) {
    if (this.tooltip && !this.tooltip.contains(event.target)) {
      this.setState(() => ({ isOpen: false }));
    }
  }

  calculateAlignment() {
    if (!this.handle) {
      return;
    }

    const windowCenter = window.innerWidth / 2;
    const handleProps = this.handle.getBoundingClientRect();
    const handleCenter = handleProps.right - handleProps.width / 2;

    // detecting the alignment based on the handle position on the screen
    return windowCenter >= handleCenter ? 'left' : 'right';
  }

  showTooltip() {
    if (this.state.isOpen) {
      return;
    }

    this.setState(() => ({
      isOpen: true,
      alignment: this.calculateAlignment(),
    }));
  }

  hideTooltip() {
    this.setState(() => ({ isOpen: false }));
  }

  render() {
    const { children, text } = this.props;
    const { isOpen, alignment } = this.state;
    const classes = classnames('c-tooltip', 'c-tooltip--s-to-m', {
      'c-tooltip--open': isOpen,
    });

    return (
      <span
        className={classes}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
        onFocus={this.showTooltip}
        onBlur={this.hideTooltip}
        onTouchStart={this.showTooltip}
        ref={tooltip => {
          this.tooltip = tooltip;
        }}
      >
        <span className="c-tooltip__container">
          <span
            tabIndex="0"
            className="c-tooltip__handle"
            ref={handle => {
              this.handle = handle;
            }}
          >
            {children}
          </span>
          <span
            className={classnames('c-tooltip__message', {
              'c-tooltip__message--right': alignment === 'right',
            })}
            role="tooltip"
          >
            {text}
          </span>
        </span>
      </span>
    );
  }
}

export default Tooltip;
